import {
  FETCH_ADDITIONAL_FEES,
  FETCH_ADDITIONAL_FEES_SUCCESS,
  FETCH_ADDITIONAL_FEES_FAILED,
  EDIT_ADDITIONAL_FEE
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, push, set, remove } from "firebase/database";

const normalizeFee = (fee) => {
  const amount = fee.amount !== undefined ? parseFloat(fee.amount) : 0;
  return {
    name: fee.name || "",
    rateType: fee.rateType || "flat",
    amount: isNaN(amount) ? 0 : amount,
    active: fee.active !== false
  };
};

export const fetchAdditionalFees = () => (dispatch) => {
  const { additionalFeesRef } = firebase;

  dispatch({
    type: FETCH_ADDITIONAL_FEES,
    payload: null,
  });

  onValue(additionalFeesRef, (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const fees = Object.keys(data).map((id) => ({
        id,
        ...normalizeFee(data[id])
      }));
      dispatch({
        type: FETCH_ADDITIONAL_FEES_SUCCESS,
        payload: fees
      });
    } else {
      dispatch({
        type: FETCH_ADDITIONAL_FEES_SUCCESS,
        payload: []
      });
    }
  }, (error) => {
    dispatch({
      type: FETCH_ADDITIONAL_FEES_FAILED,
      payload: error && error.message ? error.message : "Unable to fetch additional fees.",
    });
  });
};

export const addAdditionalFee = (fee) => (dispatch) => {
  const { additionalFeesRef } = firebase;
  dispatch({ type: EDIT_ADDITIONAL_FEE, payload: "Add" });
  const payload = normalizeFee(fee);
  return push(additionalFeesRef, payload);
};

export const updateAdditionalFee = (fee) => (dispatch) => {
  const { additionalFeeEditRef } = firebase;
  dispatch({ type: EDIT_ADDITIONAL_FEE, payload: "Update" });
  const payload = normalizeFee(fee);
  return set(additionalFeeEditRef(fee.id), payload).then(() => {
    const current = store.getState().additionalfees.fees || [];
    dispatch({
      type: FETCH_ADDITIONAL_FEES_SUCCESS,
      payload: current.map((item) => item.id === fee.id ? { id: fee.id, ...payload } : item)
    });
  });
};

export const deleteAdditionalFee = (fee) => (dispatch) => {
  const { additionalFeeEditRef } = firebase;
  dispatch({ type: EDIT_ADDITIONAL_FEE, payload: "Delete" });
  return remove(additionalFeeEditRef(fee.id)).then(() => {
    const current = store.getState().additionalfees.fees || [];
    dispatch({
      type: FETCH_ADDITIONAL_FEES_SUCCESS,
      payload: current.filter((item) => item.id !== fee.id)
    });
  });
};

export const sendBookingReceipt = (bookingId) => async () => {
  const { auth, config } = firebase;
  const url = `https://us-central1-${config.projectId}.cloudfunctions.net/send_booking_receipt`;
  try {
    const currentUser = auth && auth.currentUser ? auth.currentUser : null;
    if (!currentUser) {
      throw new Error("Admin permission required.");
    }
    const idToken = await currentUser.getIdToken();
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${idToken}` },
      body: JSON.stringify({ bookingId })
    });
    const json = await res.json();
    if (!res.ok || json.error) {
      throw new Error(json.error || "Unable to send booking receipt.");
    }
    return json;
  } catch (error) {
    throw new Error(error && error.message ? error.message : "Unable to reach Send Booking Receipt function. Deploy functions first, then try again.");
  }
};
